// extracted by mini-css-extract-plugin
export default {"visible":"popover_visible__w8dd0"};